module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/20_fc269f4f387ef6adaf9a4bbd20b31bd9.jpg";